






































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { ContentCampaignCollectionType } from '@/modules/content-campaign/models/content-campaign-collection.model'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { getContentCampaignColumnsInAdmin } from '@/modules/content-campaign/models/columns/content-campaign.column'
import AdminContentCampaignCollectionRow
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignCollectionRow.vue'
import { AdminContentCampaignRoute } from '@/modules/content-campaign/routes/admin-content-campaign.route'
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کمپینهای تولید محتوا'
  },
  metaInfo: {
    title: 'کمپینهای تولید محتوا'
  },
  components: {
    TableExportButton,
    PaginationWithInput,
    FilterRow,
    TesTable
  }
})
export default class IndexPage extends mixins(
  QsPaginatableMixin,
  QsSearchableMixin
) {

  constructor(
    private readonly contentCampaignRoute: AdminContentCampaignRoute
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() contentCampaigns!: ContentCampaignCollectionType

  protected columns: QTable['columns'] = getContentCampaignColumnsInAdmin()
  protected rowComponent = AdminContentCampaignCollectionRow

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت کمپین',
      holder: 'در حال اجرا',
      default: this.contentCampaigns?.default_filters?.statuses,
      typeMode: false,
      key: 'statuses',
      items: Object.entries(this.contentCampaigns.statuses).map(([key, value]) => ({ label: value, value: key }))
    }),
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت آیتم ها',
      holder: 'همه وضعیت ها',
      typeMode: false,
      key: 'item_status',
      items: Object.entries(this.contentCampaigns.item_statuses).map(([key, value]) => ({ label: value, value: key }))
    }),
    new Filter({
      type: FilterTypes.Custom,
      component: AdminUserSearchFilter,
      title: 'کاربر',
      typeMode: false,
      key: 'user',
      props: {
        placeholder: 'جستجو کاربر'
      }
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ ثبت',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'register_from',
        to: 'register_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ تکمیل',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'completed_from',
        to: 'completed_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    })
  ]

  protected get model() {
    return this.contentCampaigns
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
